import { Loadable } from '../../Loadable';

export const AsyncAddMenuTemplate = Loadable(() => import('./Add'));
export const AsyncMenuTemplatesList = Loadable(() => import('./List'));
export const AsyncMenuItemList = Loadable(() => import('./ItemList'));
